import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../services/firebase'; // Importa a autenticação do Firebase
import { onAuthStateChanged } from 'firebase/auth';
import { getApiUrl } from '../utils/apiConfig';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false); // Estado para controlar a autorização

  useEffect(() => {
    // O onAuthStateChanged é um listener que notifica sobre mudanças no estado de login
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Usuário está logado, agora verificamos o papel
        const token = await user.getIdToken();

        try {

          // ...

          // ...
          const response = await fetch(`${getApiUrl()}/api/user-role`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (!response.ok) throw new Error('Falha ao verificar permissão.');

          const { role } = await response.json();

          if (allowedRoles.includes(role)) {
            setIsAuthorized(true); // Autorizado
          } else {
            navigate('/'); // Papel não permitido, redireciona
          }
        } catch (error) {
          navigate('/'); // Erro na verificação, redireciona
        }
      } else {
        // Usuário não está logado
        navigate('/');
      }
    });

    // Limpa o listener quando o componente é desmontado
    return () => unsubscribe();
  }, [navigate, allowedRoles]);

  // Renderiza os filhos apenas se o usuário estiver autorizado
  return isAuthorized ? children : null; // Ou um componente de "Carregando..."
};

export default ProtectedRoute;